<template>
  <InfoCard title="订单信息">
    <div class="info-row">
      <div class="label">订单状态</div>
      <div class="value">{{ orderInfo.orderStatusDesc }}</div>
    </div>
    <div class="info-row">
      <div class="label">订单号</div>
      <div class="value">{{ orderInfo.serialNo }}</div>
    </div>
    <div class="info-row">
      <div class="label">预订日期</div>
      <div class="value">{{ orderInfo.createTime ? moment(orderInfo.createTime).format('YYYY-MM-DD') : '' }}</div>
    </div>
    <div class="info-row">
      <div class="label">总金额</div>
      <div class="value">
        <span class="order-price">¥{{ orderInfo.orderAmount }}</span>
        <el-popover trigger="click" width="200" placement="bottom" v-if="priceDetails && priceDetails.length">
          <div class="price-detail">
            <div class="price-detail-item" v-for="(detail, index) in priceDetails" :key="index">
              <div class="price-type">{{ detail.passengerTypeDesc }}</div>
              <div style="padding-left: 12px;">
                <div class="price-item">
                  <div>机票价格</div>
                  <div>¥{{ detail.ticketAmount }} * {{ detail.count }}</div>
                </div>
                <div class="price-item">
                  <div>税费</div>
                  <div>¥{{ detail.taxAmount }} * {{ detail.count }}</div>
                </div>
              </div>
            </div>
            <div style="border-top: 1px solid #dedede; margin: 10px 0"></div>
            <div class="total-price">¥{{ orderInfo.orderAmount }}</div>
          </div>
          <span style="cursor: pointer; color: #d70039" slot="reference">查看明细</span>
        </el-popover>
      </div>
    </div>
  </InfoCard>
</template>

<script>
import InfoCard from "@/views/components/infoCard.vue";
import moment from "moment";
export default {
  name: "OrderInfoCard",
  components: { InfoCard },
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    },
    priceDetails: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      moment
    }
  },
};
</script>

<style lang="less" scoped>
.info-row {
  .order-price {
    font-size: 24px;
    color: #d70039;
    margin-right: 10px;
  }
}

.price-detail {
  .price-type {
    color: #000;
  }
  
  .price-item {
    display: flex; 
    align-items: center; 
    justify-content: space-between; 
    line-height: 26px;
  }
  .total-price {
    font-size: 18px;
    color: #d70039;
    text-align: right;
  }
}
</style>
